import Enrollments from '@/services/Enrollments';
import { insertScript } from './document';

export const upsertGoogleOptimizeScript = async (
  currentCourseSlug: string | null,
): Promise<void> => {
  if (!currentCourseSlug) return;

  const loadedScript = document.querySelector<HTMLScriptElement>('script[src*="googleoptimize"]');
  const isInTrial = await Enrollments.isInTrial();
  const isPostgraduateCourse = currentCourseSlug === 'pos';
  let googleOptimizeScriptId = null;

  if (isInTrial) {
    googleOptimizeScriptId = process.env.VUE_APP_TRIAL_GOOGLE_OPTIMIZE_ID;
  }

  if (isPostgraduateCourse && !isInTrial) {
    googleOptimizeScriptId = process.env.VUE_APP_POSTGRAD_GOOGLE_OPTIMIZE_ID;
  }

  if (!googleOptimizeScriptId) return;

  const isScriptAlreadyLoaded = loadedScript?.src.includes(googleOptimizeScriptId);

  if (isScriptAlreadyLoaded) return;

  loadedScript?.remove();

  const googleOptimizeScriptSrc = `https://www.googleoptimize.com/optimize.js?id=${googleOptimizeScriptId}`;

  insertScript(googleOptimizeScriptSrc);
};
